
import { H6 } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import { Href } from "../../../utils/Constant";
import { Badge, Button } from "reactstrap";
import { Bookmark, Edit, FilePlus, FileText, Trash2 } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import EditUserModal from "./EditPatientModal";
import { useState } from "react";
import { deletePatient } from "../../../Api/patient";
import ShowPatientModal from "./ShowPatientModal";
import moment from "moment";
import DraftPatientModal from "./DraftPatientModal";

interface PatientsTableBodyProps {
  patients: any
  setPatients: (patients: any) => void
}

const PatientsTableBody: React.FC<PatientsTableBodyProps> = ({ patients = [], setPatients }) => {
  const navigate = useNavigate();
  const [editUserModal, setEditUserModal] = useState(false)
  const [draftPatientModal, setDraftPatientModal] = useState(false)
  const [showUserModal, setShowUserModal] = useState(false)
  const [currentPatient, setCurrentPatient] = useState(null)
  const [selectedId, setSelectedId] = useState("")
  const draftPatient = localStorage.getItem("draftPatient")
  const getSelectedUser = () => {
    return patients.filter((user: any) => user.id === selectedId)[0];
  };

  const handleDeletePatient = async (patientId: string) => {
    const response: any = await deletePatient(patientId)

    if (response.status && response.status === "success") {
      setPatients(patients.filter((patient: any) => patient.id !== patientId));
    }
  }

  const handleShowInfo = (patient: any) => {
    setShowUserModal(true);
    setCurrentPatient(patient)
  }

  return (
    <Fragment>
      <tbody>
        {patients.length > 0 ? patients.map((patient: any, i: any) => (
          <tr key={i} style={{ cursor: 'pointer', position: "relative", backgroundColor: patient.id === draftPatient ? "#8c2dbf10" : "white" }}>
            <td>
              <div className="d-flex align-items-center justify-content-between">
                {i + 1}
              </div>
              {patient.id === draftPatient &&
                <Badge color="warning" className="d-flex align-items-center" style={{ gap: 2, padding: "3px 6px", position: "absolute", left: 16, top: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                  <Bookmark style={{ width: 14, paddingTop: 0 }} />
                  <span style={{ fontSize: 12, }}>Draft</span>
                </Badge>}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {`${patient.firstname} ${patient.lastname}`}
            </td>
            <td style={{ cursor: 'pointer', textTransform: "capitalize" }} onClick={() => handleShowInfo(patient)}>
              {patient.gender || "Prefer not to say"}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.address}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.email}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.phonenumber}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              <Badge className="text-capitalize" color={`${patient.type === "adult" ? "primary" : "secondary"}`}>{patient.type}</Badge>
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.school}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.teacher_email}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {patient.gp_email}
            </td>
            <td style={{ cursor: 'pointer' }} onClick={() => handleShowInfo(patient)}>
              {moment(patient.created_at).format("YYYY-MM-DD")}
            </td>
            <td style={{ paddingLeft: 0 }}>
              <div className="d-flex justify-content-end align-items-center" style={{ gap: '8px' }}>
                <Button
                  color={`secondary`}
                  className="d-flex align-items-center px-2 py-1"
                  style={{ gap: '4px' }}
                  onClick={() => {
                    setSelectedId(patient.id)
                    if (patient.id == draftPatient) {
                      setDraftPatientModal(true)
                    }
                    else {
                      navigate(`/patient/report_generate?patient_id=${patient.id}`)
                    }
                  }}>
                  <FilePlus style={{ width: 16 }} />{"Report"}
                </Button>
                <Button
                  color={`secondary`}
                  className="d-flex align-items-center px-2 py-1"
                  style={{ gap: '4px' }}
                  onClick={() => {
                    setEditUserModal(true)
                    setSelectedId(patient.id)
                  }}>
                  <Edit style={{ width: 16 }} />
                </Button>
                <Button
                  color={`primary`}
                  className="d-flex align-items-center px-2 py-1"
                  style={{ gap: '4px' }}
                  onClick={() => {
                    handleDeletePatient(patient.id);
                    setSelectedId(patient.id)
                  }}>
                  <Trash2 style={{ width: 16 }} />
                </Button>
              </div>
            </td>

          </tr>
        )) :
          <tr>
            <td colSpan={11} className="text-center">
              <div className="px-3 py-3">
                <span style={{ fontSize: 16 }}>No patients at the moment</span>
              </div>
            </td>
          </tr>}
      </tbody>
      {editUserModal && <EditUserModal modal={editUserModal} setModal={setEditUserModal} patient={getSelectedUser()} setPatients={setPatients} patients={patients} />}
      {draftPatientModal && <DraftPatientModal modal={draftPatientModal} setModal={setDraftPatientModal} patientId={selectedId} />}

      {
        showUserModal && <ShowPatientModal isOpen={showUserModal} toggle={() => setShowUserModal(!showUserModal)} patient={currentPatient} />
      }
    </Fragment>
  );
};

export default PatientsTableBody;
